module.exports = __webpack_public_path__ + "img/circle.b9b7a5b7.svg";